<template>
  <v-layout>
    <v-flex>
      <v-card v-if="items">
        <v-card-text>
          <div class="align" subheader v-for="item in items" :key="item.id">
            <b>{{ item.date }}</b>
            <div class="indent" v-for="questionItem in item.questionCounts" :key="questionItem.id">
              <b>{{questionItem.itemName}}</b>
              <ul v-for="(answer, index) in questionItem.answers" :key="index">
                <li>{{answer.label}} => {{answer.count}}</li>
              </ul>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<style scoped>
div.align {
  text-align: left;
}
div.indent {
  margin-left: 2em;
}
td {
  vertical-align: top;
  padding-bottom: 2em;
}
</style>

<script>
import { planningService } from "@/services/planner";

export default {
  name: "resource-planning",
  data: () => ({
    items: []
  }),
  methods: {
    resolvePlanning() {
      planningService.resolveResourcePlanning().then(result => {
        this.items = result.data;
      });
    }
  },
  created() {
    this.resolvePlanning();
  }
};
</script>
